import { useTicketContext } from '@Context/TicketContext';
import { Assigned } from '@Models/types';

interface Props {
  ticket: Assigned;
}

const Ticket: React.FC<Props> = ({ ticket }) => {
  const { selectedTicket, setSelectedTicket } = useTicketContext();

  const handleSelectTicket = (ticket: Assigned) => {
    setSelectedTicket(ticket);
  };

  return (
    <div
      onClick={() => handleSelectTicket(ticket)}
      className={`${selectedTicket?.id === ticket.id && 'bg-primary-100'} flex cursor-pointer flex-col justify-center gap-y-2 rounded-md bg-gray-200 p-4 hover:bg-primary-100`}
    >
      <label className="text-base font-bold text-primary-700 sm:text-lg md:text-xl">
        {ticket.name}
      </label>
      <label className="text-sm font-semibold md:text-base">
        Type: {ticket.record_type}
      </label>
      <div className="flex flex-row items-center justify-start gap-x-2">
        <label
          className={`rounded-md bg-primary-700 px-2 py-1 text-xs text-white`}
          style={{
            backgroundColor: ticket?.workflow_status?.color ?? '#000000',
          }}
        >
          {ticket?.workflow_status?.name ?? 'Status Unknown!'}
        </label>
      </div>
    </div>
  );
};

export default Ticket;
